import styled from 'styled-components'

const ListItemParagraph = styled.dl`
  align-items: center;
  display: flex;
  padding: 15px;
`

export default ListItemParagraph
